// src/components/EspaciosPublicos.jsx
import React, { useRef, useState, useEffect } from 'react';
import '../styles/stylesEspaciosPublicos.css';

const espacios = [
  {
    id: 1,
    titulo: 'Plaza "Los Colonizadores"',
    imagen: '/resources/plazaProgreso1.png',
    imagenes: ['/resources/plazaProgreso3.jpg', '/resources/plazaProgreso2.jpg','/resources/plazaProgreso4.jpg','/resources/plazaProgreso5.jpg',{ url: '/resources/plazaProgreso6.jpg', zoom: true },{ url: '/resources/plazaProgreso7.jpg', zoom: true },{ url: '/resources/plazaProgreso8.jpg', zoom: true }, { url: '/resources/plazaProgreso9.jpg', zoom: true }],
    descripcion: {
      intro: 'Ubicada en el corazón del "Pueblo de las Diagonales". Su diseño es pionero en el país, con diagonales que nacen en cada esquina de la plaza y conectan con los extremos del ejido urbano. En ella se encuentra el Monumento a los Colonizadores, rindiendo homenaje a quienes forjaron nuestra identidad.'
    }
  },
  {
    id: 2,
    titulo: 'Parroquia Inmaculada Concepción',
    imagen: '/resources/iglesiaCatolica6.jpg',
    imagenes: ['/resources/iglesiaCatolica1.jpg',{ url: '/resources/iglesiaCatolica2.jpg', zoom: true }, { url: '/resources/iglesiaCatolica3.jpg', zoom: true }, { url: '/resources/iglesiaCatolica4.jpg', zoom: true }, '/resources/iglesiaCatolica5.jpg'],
    descripcion: {
      intro: 'Un pilar histórico de la fe local. El edificio actual fue inaugurado en 1944, reemplazando al modesto templo de 1885. Cada 8 de diciembre, la comunidad celebra con orgullo a su Santa Patrona, la Inmaculada Concepción, en una festividad que une a todo el pueblo.'
    }
  },
  {
    id: 3,
    titulo: 'Iglesia Evangélica del Río de la Plata',
    imagen: '/resources/iglesiaEvangelica1.jpg',
    imagenes: [ '/resources/iglesiaEvangelica2.jpg'],
    zoomGeneral: true, 
    descripcion: {
      intro: 'Representa la herencia de los inmigrantes alemanes y suizos. Fundada en 1887, su templo actual data de 1893. Es un testimonio vivo de la tradición reformada y luterana que los colonos trajeron consigo, manteniendo viva la fe y las costumbres de sus antepasados.'
    }
  },
  {
    id: 4,
    titulo: 'Casa de la Cultura "Emilio Hunziker"',
    imagen: '/resources/casaCultura1.png',
    imagenes: [ '/resources/casaCultura2.jpg'],
    zoomGeneral: true,
    descripcion: {
      intro: 'Funciona en una casona antigua de fines del siglo XIX con ventanales altos y pisos de mosaicos coloridos. Es el centro neurálgico del arte local, ofreciendo talleres, seminarios y un Centro Tecnológico Comunitario. Antiguamente fue sede de la escuela media y jardín de infantes.'
    }
  },
   {
    id: 5,
    titulo: 'Museo Comunal (Ex Molino Harinero)',
    imagen: '/resources/museo1.jpg',
    imagenes: [ '/resources/museo2.webp'],
    descripcion: {
      intro: 'Ubicado frente a la Plaza Los Colonizadores, este edificio de 1884 es uno de los tesoros arquitectónicos más antiguos de Progreso. Originalmente fue el primer gran establecimiento industrial de la zona: un Molino Harinero a vapor que abastecía a todas las colonias del norte antes de la llegada del ferrocarril.',
      items: [
        'Hogar del Fundador: La casona fue la residencia de Christian Claus, administrador y figura clave en la fundación del pueblo, quien vivió allí hasta su fallecimiento en 1916.',
        'Legado Industrial: Aunque un incendio destruyó la parte fabril en 1895, hoy perdura la estructura habitacional y de administración, recuperada por la Comuna para preservar la memoria colectiva.',
        'Restauración: Recientemente se renovó su fachada e iluminación, transformándolo en un espacio permanente para recordar la historia de los pioneros y el esfuerzo de la colonización.'
      ]
    }
  },
  {
    id: 6,
    titulo: 'Sociedad Italiana de Socorros Mutuos',
    imagen: '/resources/sociedadItaliana1.jpg',
    imagenes: [ '/resources/sociedadItaliana2.jpg'],
    zoomGeneral: true,
    descripcion: {
      intro: 'Fundada en 1892, es la institución con la personería jurídica más antigua de la localidad. Pasó de ser un centro de asistencia para inmigrantes a un referente de la vida social y recreativa, siendo famosa en toda la región por sus grandes bailes y eventos en su remodelado salón.'
    }
  },
  {
    id: 7,
    titulo: 'Club Atlético y Social San Martín',
    imagen: { url: '/resources/sanMartin1.jpeg', zoom: true },
    imagenes: [{ url: '/resources/tenis1.jpg', zoom: true } ,'/resources/sanMartin5.jpg',{ url: '/resources/sanMartin4.jpg', zoom: true }, { url: '/resources/sanMartin3.jpg', zoom: true }, { url: '/resources/sanMartin2.jpg', zoom: true }, '/resources/sanMartin6.jpg','/resources/sanMartin7.jpg','/resources/gimnasioSanMartin1.jpg','/resources/gimnasioSanMartin2.jpg'],
    descripcion: {
      intro: 'El gigante deportivo de Progreso. Fundado en 1917, hoy nuclea disciplinas como fútbol donde fue campeon de la Liga Esperancina en 2 oportunidades, tenis, básquet, patín y hockey. Es el corazón deportivo donde cientos de jóvenes y adultos se encuentran a diario.'
    }
  },
  /* --- NUEVO: HIPÓDROMO --- */
  {
    id: 8,
    titulo: 'Hipódromo "San Martín" (Jockey Club)',
    imagen: { url: '/resources/hipodromo1.jpg', zoom: true },
    zoomGeneral: true,
    descripcion: {
      intro: 'Un emblema de la tradición hípica en la región. El Hipódromo de Progreso convoca multitudes en sus jornadas de turf, siendo reconocido por la calidad de sus instalaciones y la pasión que despierta en cada carrera. Es un punto de encuentro social ineludible los fines de semana.'
    }
  },
  {
    id: 9,
    titulo: 'Paisajes del Cululú y el Espinal',
    imagen: '/resources/arroyo2.jpg',
    imagenes: ['/resources/arroyo1.jpg', '/resources/monte1.jpg', '/resources/arroyo3.jpg', '/resources/arroyo4.jpg', '/resources/arroyo5.jpg','/resources/espinal1.jpg','/resources/arroyo6.png','/resources/arroyo7.png'],
    descripcion: {
      intro: 'Progreso se asienta en una zona de transición entre la pampa y el bosque chaqueño. El paisaje ofrece vistas únicas de los arroyos Cululú y Corrales, con su lecho de tosca y saltos naturales. Es un refugio de biodiversidad donde aún persisten relictos del monte nativo santafesino.'
    }
  },
  {
    id: 10,
    titulo: 'Instituciones Educativas',
    imagen: '/resources/escuelaSecundaria.jpg',
    imagenes: ['/resources/jardinInfantes.jpg', '/resources/escuelaPrimaria.jpg', '/resources/escuelaRuralSur.jpg', '/resources/escuelaRuralNorte.jpg'],
    descripcion: {
      intro: 'Progreso prioriza la formación de sus ciudadanos con una oferta educativa completa que abarca tanto el ejido urbano como la colonia:',
      items: [
        'Jardín de Infantes N° 131: Un espacio moderno y dedicado exclusivamente al desarrollo de las primeras infancias.',
        'Escuela Primaria N° 341 "José María Paz": Institución fundamental que ha educado a generaciones de progresinos en el pueblo.',
        'Escuela Secundaria N° 253 "Mariano Moreno": Brinda formación media de calidad, permitiendo que los jóvenes completen sus estudios en la localidad.',
        'Escuela Rural N° 342 "Tomás Godoy Cruz" (Zona Sur): Garantiza el derecho a la educación de las familias que viven en el campo, evitando el desarraigo de los niños del sector sur.',
        'Escuela Rural N° 1183 "Brigadier Estanislao López" (Zona Norte): Ubicada en el sector norte del pueblo, es un pilar fundamental para la escolaridad y la comunidad de esa zona rural.'
      ]
    }
  },
  {
    id: 11,
    titulo: 'Centro Cívico y Salud',
    imagen: '/resources/comuna.jpg',
    imagenes: ['/resources/samco.jpg', '/resources/subcomisaria.jpg'],
    descripcion: {
      intro: 'Ubicado frente a la plaza principal, el Centro Cívico concentra la vida administrativa y el cuidado de la comunidad.',
      items: [
        'Comuna de Progreso: El moderno edificio comunal, inaugurado en 2003, donde se gestiona el crecimiento del pueblo.',
        'SAMCo: El espacio de salud por excelencia, que brinda atención primaria, emergencias y traslados para todos los habitantes.',
        'Seguridad y Justicia: En la misma cuadra funcionan la Subcomisaría y el Juzgado de Paz, instituciones históricas de la localidad.'
      ]
    }
  },
   {
    id: 12,
    titulo: 'Bomberos Voluntarios',
    imagen: '/resources/bomberos.jpg',
    zoomGeneral: true,
    descripcion: {
      intro: 'Una institución vital basada en el valor y el compromiso. El cuartel de Bomberos Voluntarios no solo brinda seguridad ante emergencias y accidentes en la región, sino que es un símbolo de la solidaridad y el esfuerzo colectivo de los vecinos.'
    }
  },
  {
    id: 13,
    titulo: 'Recreación y Parques',
    imagen: '/resources/parqueSanAntonio.jpg',
    imagenes: ['/resources/plazoletaDelTrabajador.jpg', '/resources/parqueSur.jpg', '/resources/juegosCiclovia.png', '/resources/parqueAsadores.png', { url: '/resources/entradaPueblo.jpg', zoom: true }],
    descripcion: {
      intro: 'Nuestra localidad ofrece diversos espacios al aire libre diseñados para el encuentro familiar y la recreación.',
      items: [
        'Áreas de Picnic y Asadores: Sectores equipados con parrillas y mesas, ideales para disfrutar de los fines de semana al aire libre.',
        'Parques de Diversión: Espacios con juegos infantiles modernos y seguros para los más chicos.',
        'Paseos del Pueblo: Senderos rodeados de vegetación nativa y bancos para disfrutar de la tranquilidad que caracteriza a nuestro entorno.'
      ]
    }
  },
   {
    id: 14,
    titulo: 'Conciencia Ambiental y Vivero Comunal',
    imagen: '/resources/vivero1.jpg',
    imagenes: ['/resources/plantaRecicladora.jpg'],
    descripcion: {
      intro: 'El compromiso con el medio ambiente se refleja en la Planta de Reciclaje, donde se procesan los residuos de la localidad. Este circuito se complementa con el Vivero Comunal, encargado de la reforestación y el mantenimiento de las especies que embellecen nuestras calles y plazas.'
    }
  },
   {
    id: 15,
    titulo: 'Terminal y Club de Abuelos',
    imagen: { url: '/resources/terminal1.jpg', zoom: true },
    imagenes: [{ url: '/resources/terminal2.jpg', zoom: true }, '/resources/clubAbuelos1.png'],
    descripcion: {
      intro: 'La Terminal de Ómnibus es el punto de conexión diaria para estudiantes y trabajadores que viajan por la región. Muy cerca, en construcción el Club de los Abuelos se destaca como un espacio de encuentro, alegría y contención, donde nuestros mayores comparten talleres, bailes y actividades recreativas.'
    }
  },
   {
    id: 16,
    titulo: 'Pampa Cheese',
    imagen: '/resources/fabrica1.jpg',
    descripcion: {
      intro: 'Progreso se proyecta al mundo a través de su industria láctea. Pampa Cheese es una planta modelo que produce quesos mozzarella de exportación, llegando a mercados internacionales como Asia. Representa la evolución del antiguo molino harinero hacia la tecnología alimentaria actual.'
    }
  },
  /* --- NUEVO: TALLER BARZAGUI --- */
  {
    id: 17,
    titulo: 'Taller Barzaghi',
    imagen: '/resources/tallerBarzaghi1.jpg', // Asegúrate de tener esta foto
    descripcion: {
      intro: 'El tradicional taller de Progreso dedicado a la reparación integral de automóviles. Especializado en chapa y pintura, cuenta con tres áreas de trabajo diferenciadas para garantizar la mejor calidad: sector de armado y desarmado, terminaciones de chapa y cabina de pintura, reconocido por su trayectoria en la localidad.'
    }
  },
  /* --- NUEVO: METALÚRGICA KERN --- */
  {
    id: 18,
    titulo: 'Metalúrgica Kern',
    imagen: '/resources/metalurgicaKern1.jpg', // Asegúrate de tener esta foto
    descripcion: {
      intro: 'Industria familiar de gran trayectoria, dedicada a la fabricación de implementos agrícolas. Metalúrgica Kern representa el espíritu emprendedor de la localidad, generando empleo y aportando al desarrollo industrial de la región.'
    }
  }
];

const EspaciosPublicos = () => {
  const scrollRef = useRef(null);
  const [abierto, setAbierto] = useState(null);
  const [currentImgIndex, setCurrentImgIndex] = useState(0);

  const abrirModal = (espacio) => {
    setAbierto(espacio);
    setCurrentImgIndex(0);
  };

  // --- LÓGICA DE ZOOM MEJORADA ---
  const obtenerGaleria = () => {
    if (!abierto) return [];
    
    // 1. Verificar si hay un zoom general para todo el ID
    const zoomGeneralActivado = abierto.zoomGeneral === true;

    // 2. Juntamos imagen principal + secundarias
    const todas = [abierto.imagen, ...(abierto.imagenes ?? [])];

    // 3. Procesamos cada item
    return todas.map(item => {
      // Si es Objeto ({ url: '...', zoom: true })
      if (typeof item === 'object' && item !== null) {
        return { 
            src: item.url || item.src, 
            zoom: zoomGeneralActivado || item.zoom // Gana el general O el individual
        };
      }
      // Si es String (Ruta normal)
      return { 
          src: item, 
          zoom: zoomGeneralActivado // Hereda el general si existe
      };
    });
  };

  const galeriaActual = obtenerGaleria(); 
  // --------------------------------------

  const scrollLeft = () => {
    if (!scrollRef.current) return;
    const card = scrollRef.current.querySelector('.espacio-card');
    if (!card) return;
    const gap = 8; 
    scrollRef.current.scrollBy({ left: -(card.offsetWidth + gap), behavior: 'smooth' });
  };

  const scrollRight = () => {
    if (!scrollRef.current) return;
    const card = scrollRef.current.querySelector('.espacio-card');
    if (!card) return;
    const gap = 8;
    scrollRef.current.scrollBy({ left: card.offsetWidth + gap, behavior: 'smooth' });
  };

  useEffect(() => {
    if (abierto) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
    return () => {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
  }, [abierto]);

  return (
    <section className="espacios-section" id="espaciosPublicos">
      <h2>Lugares destacados en nuestra localidad</h2>

      <button className="scroll-btn left" onClick={scrollLeft} aria-label="Anterior">‹</button>

      <div ref={scrollRef} className="espacios-container">
        {espacios.map((esp) => {
            // Lógica simple para mostrar la miniatura en la tarjeta (siempre toma la url string)
            const imgPortada = (typeof esp.imagen === 'object') ? esp.imagen.url : esp.imagen;
            
            return (
              <div key={esp.id} className="espacio-card">
                <div className="espacio-cara">
                  <img className="espacio-imagen" src={imgPortada} alt={esp.titulo} />
                  <div className="espacio-barra">
                    <h3 className="espacio-titulo">{esp.titulo}</h3>
                    <button className="espacio-btn" onClick={() => abrirModal(esp)} aria-label="Ver más">▼</button>
                  </div>
                </div>
              </div>
            );
        })}
      </div>

      <button className="scroll-btn right" onClick={scrollRight} aria-label="Siguiente">›</button>

      {/* MODAL */}
      {abierto && (
        <div className="espacio-modal" role="dialog" aria-modal="true">
          <div className="espacio-modal__backdrop" onClick={() => setAbierto(null)} />

          <div className="espacio-modal__panel" style={{ "--modal-bg": `url(${galeriaActual[currentImgIndex]?.src})` }}>
            <button className="espacio-modal__close" onClick={() => setAbierto(null)}>✕</button>

            {/* HERO IMAGE */}
            <div className="espacio-modal__heroWrap">
                <img
                  className={`espacio-modal__hero ${galeriaActual[currentImgIndex]?.zoom ? 'img-zoom-extra' : ''}`}
                  src={galeriaActual[currentImgIndex]?.src}
                  alt={abierto.titulo}
                />

                {/* MINIATURAS */}
                {galeriaActual.length > 1 && (
                  <div className="espacio-modal__thumbnailsOver">
                    <div className="espacio-modal__thumbnailsTrack">
                      {galeriaActual.map((foto, i) => (
                        <button
                          key={i}
                          type="button"
                          className={`espacio-modal__thumbBtn ${i === currentImgIndex ? 'activo' : ''}`}
                          onClick={() => setCurrentImgIndex(i)}
                          aria-label={`Foto ${i + 1}`}
                        >
                          <img
                            className="espacio-modal__thumbnail"
                            src={foto.src}
                            alt={`Miniatura ${i}`}
                          />
                        </button>
                      ))}
                    </div>
                  </div>
                )}
            </div>

            {/* CONTENIDO TEXTO */}
            <div className="espacio-modal__content">
              <h3 className="espacio-modal__title">{abierto.titulo}</h3>
              {abierto.descripcion?.intro && (
                <p className="espacio-modal__desc">{abierto.descripcion.intro}</p>
              )}
              {Array.isArray(abierto.descripcion?.items) && abierto.descripcion.items.length > 0 && (
                <ul className="espacio-modal__lista">
                  {abierto.descripcion.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              )}
            </div>

          </div>
        </div>
      )}
    </section>
  );
};

export default EspaciosPublicos;